var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import StyledIconWrapper from './style';
import Text from '../Text';
var Icon = function (_a) {
    var icon = _a.icon, _b = _a.width, width = _b === void 0 ? '24px' : _b, _c = _a.backgroundSize, backgroundSize = _c === void 0 ? '36px' : _c, withBackground = _a.withBackground, suffix = _a.suffix, disabled = _a.disabled, color = _a.color, _d = _a.reverseOnRtl, reverseOnRtl = _d === void 0 ? false : _d, props = __rest(_a, ["icon", "width", "backgroundSize", "withBackground", "suffix", "disabled", "color", "reverseOnRtl"]);
    var IconComponent = icon;
    return (React.createElement(StyledIconWrapper, __assign({ withBackground: withBackground, disabled: disabled, backgroundSize: backgroundSize, color: color, reverseOnRtl: reverseOnRtl, suffix: suffix, width: width }, props),
        React.createElement(IconComponent, __assign({ width: width, fill: color, stroke: color }, props)),
        React.createElement(Text, { variant: "smallText", cursor: disabled ? 'default' : 'pointer', mx: suffix ? 1 : 0 }, suffix === null || suffix === void 0 ? void 0 : suffix.toString())));
};
export default Icon;
